// @flow
import Analytics, { AnalyticsPlugin, AnalyticsInstance } from 'analytics'

export const createAnalyticsInstance = (plugin: AnalyticsPlugin): AnalyticsInstance =>
  Analytics({
    app: process.env.REACT_APP_ENV,
    debug: process.env.NODE_ENV === 'development',
    plugins: [plugin],
  })
